import { render, staticRenderFns } from "./passo0.vue?vue&type=template&id=58492d06&scoped=true&"
import script from "./passo0.vue?vue&type=script&lang=js&"
export * from "./passo0.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58492d06",
  null
  
)

export default component.exports